import { Observable } from "rxjs";

import * as http from "../../../services/http.service";
import { SearchResults } from "../../../types/search/search-results.interface";

import { ISearchParams } from "../types/app-search.types";

export const mapSearchParams = (params: ISearchParams): any => {
  return {
    q: params.searchTerm,
    limit: params.limit,
    offset: params.offset,
  };
};

export const mapPayloadData = (data: any, dataKey: string) => {
  if (dataKey !== "") {
    const { results, ...pagination } = data;
    return { [dataKey]: results, pagination };
  } else {
    return { ...data, pagination: null };
  }
};

export function searchApp(
  endpoint: string,
  dataKey: string,
  searchParams: ISearchParams
): Observable<SearchResults<any>> {
  const params = mapSearchParams(searchParams);
  return http.get<any>(`/search/${endpoint}`, { params });
}
